// =============================================================================
// widget-links — build customer-facing booking-widget deep links
// =============================================================================
// The booking widget (neoseum.com) resolves ?location=<slug-or-uuid> against
// either infra.location.slug or its UUID. Staff use these links two ways:
//   * a normal deep link for a listed location (QR codes / marketing), and
//   * a *bypass link* for a bookable-but-hidden location (booking_listed=false)
//     that doesn't appear in the public picker.
// Both are the same URL shape; the difference is purely whether the location is
// listed. Kept here (pure, no DOM) so it's unit-testable on its own.
// =============================================================================

// Public widget origin. Constant for now (no env wiring) — the widget is always
// served from neoseum.com.
export const WIDGET_BASE_URL = 'https://neoseum.com';

// Build a ?location= deep link from a slug (preferred, human-readable) or a
// UUID fallback when the location has no slug.
export function locationDeepLink(slugOrId: string): string {
  return `${WIDGET_BASE_URL}/?location=${slugOrId}`;
}
